import { render } from "./leads-index.vue?vue&type=template&id=8f5ee7f4"
import script from "./leads-index.vue?vue&type=script&lang=js"
export * from "./leads-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__